export enum StagePosition {
  FIRST = "first",
  AFTER_PREFIX = "after_",
  LAST = "last"
}

export interface BaseStageRow {
  id: string | number;
  name: string;
}

export interface PositionOption {
  id: string;
  displayName: string;
}
